import { render, staticRenderFns } from "./detalhes-rh.vue?vue&type=template&id=1f44865e&scoped=true&"
import script from "./detalhes-rh.vue?vue&type=script&lang=js&"
export * from "./detalhes-rh.vue?vue&type=script&lang=js&"
import style0 from "../styles/report.scss?vue&type=style&index=0&id=1f44865e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f44865e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VCarousel,VCarouselItem,VPagination})
